import { FaHome, FaHandHoldingUsd, FaHandshake } from "react-icons/fa";
import { FaUsers, FaLightbulb, FaBullhorn } from "react-icons/fa6";
import { MdOutlinePersonSearch } from "react-icons/md";

const KWFDifference = () => {
  return (
    <section
      className={`md:py-16 py-[24px] px-[16px] sm:px-6 md:px-12 lg:px-20 bg-white text-gray-900 relative`}
    >
      <div className="max-w-[1380px] mx-auto">
        {/* Heading */}
        <h2 className="text-2xl md:text-4xl font-bold sm:text-center md:mb-12 mb-[24px]">
          How KWF Make A Difference
        </h2>

        {/* Top Cards */}
        <div className="flex  sm:flex-row flex-col items-start justify-center gap-8 md:mb-16 mb-[30px]">
          {/* Card 1 */}
          <div className="bg-[#0EA5A4] text-white p-8 sm:w-1/3 w-full ">
            <div className="bg-white p-3 rounded-full text-primary-green mb-4 w-max">
              <FaHome className="text-4xl" />
            </div>
            <h3 className="text-xl font-semibold mb-3">
              Food & Homeless Charity
            </h3>
            <p className="text-sm leading-relaxed mb-4 text-justify">
              At KWF, We Strive To Feed The Hungry And Shelter The Homeless
              Across Pakistan. Our Mission Is To Restore Dignity And Hope To
              Every Vulnerable Soul We Encounter.
            </p>
            <ul className="list-decimal font-semibold space-y-1 text-sm">
              <li>Providing Meals For The Hungry.</li>
              <li>Offering Safe Spaces To The Homeless.</li>
            </ul>
          </div>

          {/* Card 2 */}
          <div
            className={`p-8 bg-[#EDF5F6] sm:w-1/3 w-full
          }`}
          >
            <div className="bg-white p-3 rounded-full text-primary-green mb-4 w-max">
              <FaHandHoldingUsd className="text-4xl" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Make A Donation</h3>
            <p className="text-sm leading-relaxed mb-4 text-justify">
              Donating To KWF Means Investing In A Future Where Every Person
              Lives With Dignity. Even The Smallest Donation Can Create A Big
              Impact.
            </p>
            <ul className="list-decimal font-semibold 1 space-y-1 text-sm">
              <li>Feed Families In Need.</li>
              <li>Build Shelters For The Homeless.</li>
              <li>Fund Healthcare And Education Programs.</li>
            </ul>
          </div>

          {/* Card 3 */}
          <div
            className={`p-8 bg-[#EDF5F6] sm:w-1/3 w-full
          }`}
          >
            <div className="bg-white p-3 rounded-full text-primary-green mb-4 w-max">
              <FaHandshake className="text-4xl " />
            </div>
            <h3 className="text-xl font-semibold mb-3">Non Profit NGO</h3>
            <p className="text-sm leading-relaxed mb-4 text-justify">
              KWF Is A Registered Non-Profit NGO Working Across Pakistan To
              Uplift Underprivileged Communities. We Focus On Sustainable
              Solutions And Real Transformation.
            </p>
            <ul className="font-semibold space-y-1 text-sm list-decimal">
              <li>Transparency In Operations.</li>
              <li>Commitment To Inclusivity.</li>
              <li>Sustainable Programs For Long-Term Impact.</li>
              <li>Accountability To Donors And Beneficiaries.</li>
            </ul>
          </div>
        </div>

        {/* Our Goals */}
        <div className="flex items-center md:gap-[60px] xl:gap-[100px] gap-[16px] md:flex-row flex-col">
          <div className="text-left md:w-[40%] lg:w-[35%] w-full">
            <h4 className="text-primary-green font-bold text-2xl leading-[18px] md:mb-8 mb-[16px]">
              Our Goals
            </h4>
            <h2 className="text-2xl md:text-3xl font-bold mt-2 mb-4 font-roboto">
              Together, we are redefining the future.
            </h2>
            <p className="max-w-2xl mx-auto text-sm md:text-base text-justify text-gray">
              We believe in a world where compassion turns into action, and no
              one is left behind.
            </p>
          </div>

          {/* Goals Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-8 gap-[24px] lg:w-[65%] md:w-[60%] w-full">
            {/* Empowerment */}
            <div className="flex flex-col items-start">
              <div className="p-2 rounded-full bg-[#EDF5F7] text-primary-green mb-3">
                <FaLightbulb className="text-3xl" />
              </div>
              <h5 className="font-semibold mb-2">Empowerment</h5>
              <p className="text-sm sm:max-w-2/3 text-justify text-gray">
                Enable individuals to take control of their lives through access
                to education, employment, and resources.
              </p>
            </div>

            {/* Community Building */}
            <div className="flex flex-col items-start">
              <div className="p-2 rounded-full bg-[#EDF5F7] text-primary-green mb-3">
                <FaUsers className=" text-3xl" />
              </div>
              <h5 className="font-semibold mb-2">Community Building</h5>
              <p className="text-sm sm:max-w-2/3 text-justify text-gray">
                Foster unity and collaboration to create stronger, more
                resilient societies.
              </p>
            </div>

            {/* Personalized Approach */}
            <div className="flex flex-col items-start">
              <div className="p-2 rounded-full bg-[#EDF5F7] text-primary-green mb-3">
                <MdOutlinePersonSearch className=" text-3xl" />
              </div>
              <h5 className="font-semibold mb-2">Personalized Approach</h5>
              <p className="text-sm sm:max-w-2/3 text-justify text-gray">
                Tailor solutions to fit the unique needs of each community and
                individual we serve.
              </p>
            </div>

            {/* Advocacy */}
            <div className="flex flex-col items-start">
              <div className="p-2 rounded-full bg-[#EDF5F7] text-primary-green mb-3">
                <FaBullhorn className=" text-3xl" />
              </div>
              <h5 className="font-semibold mb-2">Advocacy and Awareness</h5>
              <p className="text-sm sm:max-w-2/3 text-justify text-gray">
                Raise critical awareness about social issues and advocate for
                the rights of the underprivileged.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KWFDifference;
